import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import * as THREE from 'three';

export function Fire({ progress }: { progress: number }) {
  const flame = useRef<THREE.Mesh>(null);
  const light = useRef<THREE.PointLight>(null);
  useFrame(({ clock }) => {
    const visibility = THREE.MathUtils.smoothstep(progress, 0.38, 0.46) * (1 - THREE.MathUtils.smoothstep(progress, 0.54, 0.62));
    if (flame.current) {
      flame.current.visible = visibility > 0.01;
      flame.current.scale.set(0.7 + Math.sin(clock.elapsedTime * 8) * 0.08, 1 + Math.sin(clock.elapsedTime * 11) * 0.14, 0.7);
      flame.current.material instanceof THREE.MeshStandardMaterial && (flame.current.material.opacity = visibility);
    }
    if (light.current) light.current.intensity = visibility * (15 + Math.sin(clock.elapsedTime * 15) * 3);
  });
  return (
    <group position={[0, -1.5, -0.5]}>
      <mesh ref={flame}>
        <coneGeometry args={[0.38, 1.3, 32]} />
        <meshStandardMaterial color="#ff6b20" emissive="#ff2700" emissiveIntensity={5} transparent />
      </mesh>
      <pointLight ref={light} color="#ff5a24" distance={8} decay={2} />
    </group>
  );
}
